import { useTranslation } from "react-i18next";

import { useEffect, useMemo, useState } from "react";
import { ButtonProps } from "@ttc3k/trekker";
import { ArrowRight } from "iconoir-react";

export enum NewWidgetStep {
  SelectWidgetType = "WIDGET_TYPE",
  SelectedOperator = "WIDGET_TYPE_OPERATOR",
  SelectedEvent = "WIDGET_TPYE_EVENT",
}

type StartNewWidgetModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const useStartNewWidgetModal = ({
  isOpen,
  onClose,
}: StartNewWidgetModalProps) => {
  const { t } = useTranslation("widgets", {
    keyPrefix: "CREATE_NEW",
  });

  // The create widget step
  const [step, setStep] = useState<NewWidgetStep>(
    NewWidgetStep.SelectWidgetType,
  );

  // If the modal is open, set the step to the initial step
  useEffect(() => {
    if (isOpen) {
      setStep(NewWidgetStep.SelectWidgetType);
    }
  }, [isOpen]);

  const modalTitle = useMemo(
    () =>
      step === NewWidgetStep.SelectWidgetType
        ? t("TITLE")
        : step === NewWidgetStep.SelectedOperator
          ? t("OPERATOR_WIDGET.TITLE")
          : t("EVENT_WIDGET.TITLE"),
    [step, t],
  );

  const [onCloseClick, setOnCloseClick] = useState<() => void>(() => {});
  const [cancelButtonProps, setCancelButtonProps] = useState<ButtonProps>({});
  useEffect(() => {
    setOnCloseClick(() => onClose);
    setCancelButtonProps((prev: ButtonProps) => ({
      ...prev,
      onClick: () => onClose(),
    }));
  }, [onClose]);

  const [nextButtonProps, setNextButtonProps] = useState<ButtonProps>({
    visual: "accent.blue",
    Icon: ArrowRight,
    isIconRightAligned: true,
    disabled: true,
    onClick: () => {},
  });

  return {
    step,
    setStep,
    modalTitle,
    onCloseClick,
    setOnCloseClick,
    cancelButtonProps,
    setCancelButtonProps,
    nextButtonProps,
    setNextButtonProps,
  };
};
